export default __webpack_public_path__ + "mobile_01-c1523456248433882a3641c793b6c164.jpg";